import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme }) => ({
    '& .Button-Set': {
        maxWidth: 360,

        [theme.breakpoints.up('md')]: {
            maxWidth: 9999,
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: toRem(65)
        },

        '& a': {
            width: '100%',
            marginBottom: toRem(10),
            justifyContent: 'left',
            height: '60px',
            padding: '20px 40px',
            color: theme.colors.blueLight,

            [theme.breakpoints.up('md')]: {
                width: '24.5%',
                height: '80px',
                justifyContent: 'center',
                padding: toRem(20)
            },

            '& span': {
                display: 'flex',
                alignItems: 'center'
            },

            '.icon': {
                lineHeight: 0,

                svg: {
                    path: {
                        fill: theme.colors.blueLight
                    }
                }
            },

            '.content': {
                fontSize: toRem(14),
                marginLeft: 20,

                [theme.breakpoints.up('860')]: {
                    fontSize: toRem(16)
                }
            }
        }
    }
})

export default style
